import { useLocalStorage } from 'usehooks-ts';
import useGetLocation from '../utilities/useGetLocation';
export default function usePaymentProvider() {
  const {
    geoCountry,
    geoState
  } = useGetLocation();
  const initPaymentProviders = () => {
    if (geoState == 'NY') {
      return ['OnRamper', 'Crypto Wallet', 'Other'];
    }
    if (geoCountry == 'US') {
      return ['Moonpay', 'Crypto Wallet', 'Other'];
    }
    return ['Moonpay', 'Crypto Wallet', 'Other'];
  };
  const initPaymentProvider = () => {
    if (geoState == 'NY') {
      return 'OnRamper';
    }
    if (geoCountry == 'US') {
      return 'Moonpay';
    }
    return 'Moonpay';
  };
  const initDropDownOptions = () => {
    if (geoState == 'NY') {
      return ['Coinbase'];
    }
    if (geoCountry == 'US') {
      return ['OnRamper', 'Coinbase'];
    }
    return ['OnRamper', 'Coinbase'];
  };
  const initDropDownOption = (): 'OnRamper' | 'Coinbase' => {
    if (geoState == 'NY') {
      return 'Coinbase';
    }
    if (geoCountry == 'US') {
      return 'OnRamper';
    }
    return 'OnRamper';
  };
  const paymentProviders = initPaymentProviders();
  const [paymentProvider, setPaymentProvider] = useLocalStorage<'Coinbase' | 'Crypto Wallet' | 'Other' | 'OnRamper' | 'Moonpay'>('paymentProvider', initPaymentProvider());
  const dropDownOptions = initDropDownOptions();
  const [selectedDropDownOption, setSelectedDropDownOption] = useLocalStorage<'OnRamper' | 'Moonpay' | 'Coinbase'>('selectedDropDownOption', initDropDownOption());
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useLocalStorage<'coinbase_account' | 'apple' | 'google' | 'card' | 'bank' | 'evm' | 'solana' | null>('selectedPaymentMethod', null);
  const resetProvider = () => {
    setPaymentProvider(initPaymentProvider());
    setSelectedDropDownOption(initDropDownOption());
    setSelectedPaymentMethod(null);
  };
  const utilizedProvider = paymentProvider === 'Other' ? selectedDropDownOption : paymentProvider;
  const useOnRamper = utilizedProvider === 'OnRamper';
  return {
    paymentProviders,
    paymentProvider,
    setPaymentProvider,
    dropDownOptions,
    selectedDropDownOption,
    setSelectedDropDownOption,
    utilizedProvider,
    resetProvider,
    useOnRamper,
    selectedPaymentMethod,
    setSelectedPaymentMethod
  };
}